// extracted by mini-css-extract-plugin
module.exports = {"pill":"_1mVY0PLH5BFA8qSnLpy7yO","closePill":"_3IcAn83l3mBsWTmcumBk3W"};